export default {
  drawer: (state) => state.app.drawer,
  isMobileView: (state) => state.app.isMobileView,
  sidebarCollapsed: (state) => state.app.sidebarCollapsed,
};
